import {
    IListState,
    initialListState
} from '../shared/list/list.state';

export interface IEmployeesState {
    paystubs: IListState;
    documents: IListState;
    employees: IListState;
    benefits: IListState;
    deductions: IListState;
    wages: IListState;
    viewedEmployeeId: string;
}

export function initialEmployeesState(): IEmployeesState {
    return {
        employees: {
            ...initialListState
        },
        documents: {
            ...initialListState, sortBy: null
        },
        paystubs: {
            ...initialListState, sortBy: null
        },
        benefits: {
            ...initialListState, sortBy: null
        },
        deductions: {
            ...initialListState, sortBy: null
        },
        wages: {
            ...initialListState, sortBy: null
        },
        viewedEmployeeId: null
    };
}
